module.exports = __webpack_public_path__ + "ecochat.db4dc382.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/ecochat.png
// module id = 2270
// module chunks = 0